import { useMemo, useCallback } from "react";
import { useAppSelector } from "../redux/store";
import { UserAuthResponse } from "../shared/dtos/auth/UserAuthResponse";

export interface UsePermissionsResult {
  userInfo: UserAuthResponse["userData"] | null;
  hasPermission: (requiredPermission: string) => boolean;
  hasAllPermissions: (requiredPermissions?: string[]) => boolean;
}

export const usePermissions = (): UsePermissionsResult => {
  const { userInfo } = useAppSelector((state) => state.auth);

  const userPermissions = useMemo(
    () => userInfo?.permissions || [],
    [userInfo],
  );

  const hasPermission = useCallback(
    (requiredPermission: string): boolean => {
      return userPermissions.includes(requiredPermission);
    },
    [userPermissions],
  );

  const hasAllPermissions = useCallback(
    (requiredPermissions: string[] = []): boolean => {
      if (requiredPermissions.length === 0) {
        return true;
      }
      return requiredPermissions.every((p) => userPermissions.includes(p));
    },
    [userPermissions],
  );

  return { userInfo, hasPermission, hasAllPermissions };
};
